export default function sendBackRoutes(data) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ data: { setHomePage: data } })
    );
  }
}
